import { QIcon_search_default } from '@repo/icons/index'
import { ActivityComponentType } from '@stackflow/react'
import { n_material_list } from '../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../modules/i18n/useTranslation'
import { useMaterialsStack } from '../../../pages/[lang]/webview/materials'
import SelectMaterialBody from '../../new-portal/lessons/materials/SelectMaterialBody'
import WebviewStackContainer from '../common/WebviewStackContainer'

const SearchIcon = () => {
  const { useMaterialsFlow } = useMaterialsStack()
  const { push } = useMaterialsFlow()
  const handleClickSearch = () => {
    push('MaterialsSearchActivity', {})
  }
  return (
    <>
      <div
        className="absolute top-[0px] right-[0px] z-[10] flex cursor-pointer items-end pt-[14px] pr-[20px]"
        onClick={handleClickSearch}
      >
        <QIcon_search_default width={24} height={24} />
      </div>
    </>
  )
}
const MaterialsListActivity: ActivityComponentType = () => {
  const { t } = useTranslation()
  const { useMaterialsFlow } = useMaterialsStack()
  const { pop } = useMaterialsFlow()

  return (
    <WebviewStackContainer
      height="52px"
      title={t(n_material_list.all.title)}
      onBack={pop}
      appendRight={() => <SearchIcon />}
    >
      <div className="mx-[16px]">
        <SelectMaterialBody isList={true} />
      </div>
    </WebviewStackContainer>
  )
}

export default MaterialsListActivity
